<template>
  <BaseSmartGateAutocompleteSelect
    :warehouse-id="warehouseId"
    field-label="Select License Plate (e.g. 215BG2)"
    field-name="License Plate"
    placeholder="Search by license plate"
    test-id="comet-asset-license-plate-field"
    custom-item-test-id="comet-use-custom-license-plate"
    custom-item-class="add-custom-license-plate"
    :data-mapper="licensePlateMapper"
    :rules="rules"
    :model-value="modelValue"
    @update:model-value="$emit('update:model-value', $event)" />
</template>

<script>
import { defineComponent } from 'vue';

import BaseSmartGateAutocompleteSelect from './BaseSmartGateAutocompleteSelect.vue';

export default defineComponent({
  components: {
    BaseSmartGateAutocompleteSelect
  },
  props: {
    warehouseId: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: Object,
      default: null
    }
  },
  emits: ['update:model-value'],
  setup() {
    const licensePlateMapper = item => {
      if (item.licensePlate && item.licensePlate !== '') {
        return {
          raw: item,
          id: item.id,
          name: item.licensePlate
        };
      }
    };

    return {
      licensePlateMapper
    };
  }
});
</script>
